export default __webpack_public_path__ + "static/ebike-b3082ccab3deb7c2fb6271f647948f7a.png";